import { Toro } from '../common/enumerations';
import DeviceType = Toro.DeviceType;

export class ConnectedDevice
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);

            if (json.BusyUntilWhen) this.BusyUntilWhen = new Date(json.BusyUntilWhen);
            if (json.WhenCreated) this.WhenCreated = new Date(json.WhenCreated);
            if (json.WhenLastKnownCommunication) this.WhenLastKnownCommunication = new Date(json.WhenLastKnownCommunication);
            if (json.WhenLastUpdated) this.WhenLastUpdated = new Date(json.WhenLastUpdated);
        }
    }

    AccountId: number;
    BaseId: number;
    BootVersion: number;
    BusyUntilWhen: Date;
    CommCardId: number;
    CommCardUId: string;
    Description: string;
    DeviceGroupId: number;
    DeviceTypeId: number;
    FirmwareVersion: number;
    HardwareVersion: number;
    Id = 0;
    LocationId: number;
    Name: string;
    OrdinalPosition: number;
    Password: string;
    SecretId: string;
    UId: string;
    WasLastCommunicationInResponsiveMode: boolean;
    WhenCreated: Date;
    WhenLastKnownCommunication: Date;
    WhenLastUpdated: Date;

    CommunicationPin: string;
    parentId: number;
    costPlanId: number;
    AlreadyOwnned: boolean;

    get isEvo(): boolean
    {
        return this.DeviceTypeId === DeviceType.EVO;
    }

    get isEvoAg(): boolean
    {
        return this.DeviceTypeId === DeviceType.EVOAG;
    }

    get isRD(): boolean
    {
        return this.DeviceTypeId === DeviceType.RD;
    }

    get isKD2()
    {
        return this.DeviceTypeId === DeviceType.KD2;
    }

    //TODO LXC
    get isLXC(): boolean {
        return this.DeviceTypeId === DeviceType.LXCEXP;
    }
}

